import { ICredentialEntryField, IS3File } from '.';

export interface ICredential {
  readonly id?: string;
  readonly addedAt?: Date;
  readonly credential_type: CredentialTypeEnum;
  readonly credential_input_type: CredentialInputTypeEnum;
  readonly entry_field?: ICredentialEntryField;
  readonly files?: IS3File[];
  readonly fieldUpdated?: boolean;
}

export enum CredentialTypeEnum {
  StateLicense = 'state_license',
  DACertificate = 'da_certificate',
  Radiology = 'radiology',
  CprBls = 'cpr/bls',
  Reference = 'reference',
  Upload = 'upload',
  Npi = 'npi',
}

export enum CredentialInputTypeEnum {
  Upload = 'upload',
  EntryField = 'entry_field',
  SingleField = 'single_field',
}

export interface ICredentialV2File {
  readonly createdAt: Date;
  readonly updatedAt: Date;
  readonly id: string;
  readonly licenseId: string;
  readonly type: ICredentialV2FileType;
  readonly url: string;
}

export enum ICredentialV2FileType {
  daCertificate = 'da_certificate',
  efdaCertificate = 'efda_certificate',
  radiology = 'radiology',
  cprBls = 'cpr/bls',
}

export interface ICredentialV2Radiology {
  readonly createdAt: Date;
  readonly updatedAt: Date;
  /** YYYY-MM-DD */
  readonly expiredAt: string;
  /** YYYY-MM-DD */
  readonly issuedAt: string;
  readonly id: string;
  readonly licenseId: string;
  readonly normalizedNumber: string;
  readonly number: string;
}

export interface ICredentialV2Reference {
  readonly createdAt?: Date;
  readonly updatedAt?: Date;
  readonly contactEmail: string;
  readonly contactName: string;
  /** YYYY-MM-DD */
  readonly employmentEnd: string;
  /** YYYY-MM-DD */
  readonly employmentStart: string;
  readonly id?: string;
  readonly licenseId?: string;
}

export interface ICredentialV2State {
  readonly createdAt: Date;
  readonly updatedAt: Date;
  /** YYYY-MM-DD */
  readonly expiredAt: string;
  /** YYYY-MM-DD */
  readonly issuedAt: string;
  readonly firstName: string;
  readonly id: string;
  readonly lastName: string;
  readonly licenseId: string;
  readonly normalizedNumber: string;
  readonly number: string;
}
